import { AttacherNode } from "@animech/supermodel";

export const dynamicAttacherNodesByEntityName: Record<string, AttacherNode[]> =
	{} as const;
